import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M13.332 17.5l-7.5-7.5 7.5-7.5.835.835L7.502 10l6.665 6.665-.835.835z" fill="#000" /></svg>;